import React from 'react';

function AppLogo(props)
{
    return <img {...props} src="/logo.png" alt="Logo" />
}

export default AppLogo;